import { COOKIE_CONSENT_COPY, type Language } from '@ophelos/ui/components/legal/cookie-consent-copy';

interface CookiePolicyContentProps {
  language: Language;
}

/**
 * Ophelos cookie policy — the shared, language-selected copy shown in full.
 * Presentational only; the caller owns routing and the page shell.
 */
export function CookiePolicyContent({ language }: CookiePolicyContentProps) {
  const doc = COOKIE_CONSENT_COPY[language];

  return (
    <article className="stack gap-8 text-foreground">
      <header>
        <h1 className="text-2xl font-semibold md:text-3xl">{doc.title}</h1>
      </header>

      <p className="leading-relaxed text-muted-foreground">{doc.intro}</p>

      <div className="stack gap-6">
        {doc.categories.map((category) => (
          <section key={category.key} className="stack gap-2">
            <h2 className="text-lg font-semibold">{category.title}</h2>
            <p className="leading-relaxed text-muted-foreground">{category.body}</p>
          </section>
        ))}
      </div>

      <p className="leading-relaxed text-muted-foreground">{doc.declineNote}</p>
    </article>
  );
}
